import { api } from "./api";

export interface RoleResponse {
  id: string;
  tenantId: string;
  nome: string;
  descricao: string | null;
  permissoes: string[];
  sistema: boolean;
  createdAt: string;
}

export interface CreateRoleData {
  nome: string;
  descricao?: string;
  permissoes: string[];
}

export interface UpdateRoleData {
  nome?: string;
  descricao?: string;
  permissoes?: string[];
}

interface PaginatedRoles {
  data: RoleResponse[];
  meta: { page: number; limit: number; total: number; totalPages: number };
}

export async function listRoles(params: {
  page?: number;
  limit?: number;
  search?: string;
}): Promise<PaginatedRoles> {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", params.search);

  const response = await api.get<RoleResponse[]>(`/roles?${query.toString()}`);
  return {
    data: response.data || [],
    meta: response.meta || { page: 1, limit: 10, total: 0, totalPages: 0 },
  };
}

export async function getRole(id: string): Promise<RoleResponse> {
  const response = await api.get<RoleResponse>(`/roles/${id}`);
  return response.data!;
}

export async function createRole(data: CreateRoleData): Promise<RoleResponse> {
  const response = await api.post<RoleResponse>("/roles", data);
  return response.data!;
}

export async function updateRole(id: string, data: UpdateRoleData): Promise<RoleResponse> {
  const response = await api.put<RoleResponse>(`/roles/${id}`, data);
  return response.data!;
}

export async function deleteRole(id: string): Promise<void> {
  await api.delete(`/roles/${id}`);
}
